<template>
    <div>
        <div style="" class="d-flex justify-content-left  leftTitle mt-2 clearfix ">
            <!--<li></li>-->
            <span class="otherInfo"></span>{{$t("otherInfo.1")}}:
        </div>
        <div style="" class="mt-2 clearfix">
            <div class="otherInfoLeft  "><span class="birth"></span>{{$t("otherInfo.2")}}:</div>
            <div class="otherInfoLeft bold "><span class="birthDate">30.11.1969</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <div class="otherInfoLeft  "><span class="age"></span>{{$t("otherInfo.3")}}:</div>
            <div class="otherInfoLeft bold "><span class="ageNumber">{{ getAge('1969-11-30') }} {{$t("otherInfo.4")}}</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <div class="otherInfoLeft  "><span class="national"></span>{{$t("otherInfo.5")}}:</div>
            <div class="otherInfoLeft bold "><span class="nationalName">{{$t("otherInfo.6")}}</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                age: 54,
            }
        },
        methods: {
            getAge(birthDate) {
                const today = new Date();
                const birth = new Date(birthDate);
  
                let age = today.getFullYear() - birth.getFullYear();
                const monthDiff = today.getMonth() - birth.getMonth();
  
                // Ak ešte nemal v tomto roku narodeniny, uber 1
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
                    age--;
                }
  
                return age;
            }
        },
        mounted () {
            //this.getAge()
        },                
    }
</script>

<style lang="scss" scoped>

</style>